// Resolve the audio seek target for a click on the transcript.
//
// A read-mode click anywhere in a paragraph seeks the audio. Each word is
// rendered as a <span class="raw-token" data-token-start-ms={t.start_ms}>, so
// the turn's onClick reads the nearest token span's data-token-start-ms and
// seeks to THAT word's timestamp — making long paragraphs skimmable. When the
// click misses a word (paragraph padding, the speaker label, a corrected span
// that swallows its own click), there is no token attribute and we fall back
// to the paragraph's start_ms (the prior whole-paragraph seek behavior).
export function resolveSeekMs(
  tokenStartMsAttr: string | null | undefined,
  turnStartMs: number,
): number {
  if (tokenStartMsAttr == null || tokenStartMsAttr === "") return turnStartMs;
  const n = Number(tokenStartMsAttr);
  return Number.isFinite(n) ? n : turnStartMs;
}
